import React from "react";

export const Click = () => {
  return <div>Click</div>;
};
